
import  { login as apiLogin, 
  register as apiRegister, 
  adminlogin as apiadminLogin, 
  sendPasswordReset as apiSendPasswordReset,
  verify2FA as apiVerify2FA
} from './../api';

const keyUser = 'authx.user';

function setSession(user, token,org) {
  const merged = {
    ...user,
  };
  localStorage.setItem(keyUser, JSON.stringify(merged));
  localStorage.setItem('token', token);  // Store token separately for API interceptor
  localStorage.setItem('org', org);  
 }

function getSession() {
  const user = localStorage.getItem(keyUser);
  return JSON.parse(user);
}

function isAuth() {
  return !!getSession();
}
function isAdminAuth0() {
  const user = getSession();
  return (!!user && user['role']==="admin");
}

function isAdminAuth() {
  const user = getSession();
  if (!user) return false;
  
  // If roles is an array, check if it includes admin
  if (Array.isArray(user.roles)) {
    return user.roles.includes("admin");
  }
  
  // Fallback for legacy data where role might be a string
  if (user.role) {
    return user.role === "admin";
  }
  
  return false;
}

function isOrgAdminAuth() {
  const user = getSession();
  if (!user) return false;
  
  // If roles is an array, check if it includes admin
  if (Array.isArray(user.roles)) {
    return user.roles.includes("org_admin");
  }
  
  // Fallback for legacy data where role might be a string
  if (user.role) {
    return user.role === "org_admin";
  }
  
  return false;
}

async function login(username, password) {
  try {
    const response = await apiLogin(username, password);
    const data = response.data;
   
    if (response.status !==200) {
      throw new Error(data.message || 'Login failed');
    }

    if (data.require_2fa) {
      return { require_2fa: true, user_id: data.user_id };
    }

    //setSession(data.user);
    return data;
   
  } catch (error) {
    throw error.response.data;
  }
}
async function adminLogin(username, password) {
  try {
    const response = await apiadminLogin(username, password);
    const {user, token ,org} = response.data;
    setSession(user, token, org);
    return token;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
}
async function verify2FA (userId, twoFACode) {
  try {
    const response = await apiVerify2FA(userId, twoFACode);
    //console.log("response verify2FA:",response);
   
    if (response.status !==200) {
      throw new Error(response.data.message || 'Invalid 2FA code');
    }

    const { user, token ,org} = response.data;
    setSession(user, token,org);
    return token; 
    
  } catch (error) {
    throw error;
  }
}
async function logout() {
  try {
    //  API doesn't have a logout endpoint, so we'll just clear local storage
    localStorage.removeItem(keyUser);
    localStorage.removeItem('token');
    localStorage.removeItem('org');
  } catch (error) {
    console.error('Logout failed:', error);
  }
}

async function addUser(user) {
  try {
    const response = await apiRegister(user.username, user.password,user.firstname, user.lastname, user.email, user.phone);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add user');
  }
}

async function getUsers() {
  
  console.warn('Get users functionality not implemented in the API');
  throw new Error('Get users not implemented');
}

async function sendPasswordReset(user) {
  try {
    const response = await apiSendPasswordReset(user.email);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add user');
  }
}

export {
  getSession,
  isAuth,
  login,
  isAdminAuth,
  isOrgAdminAuth,
  adminLogin,
  logout,
  sendPasswordReset,
  addUser,
  getUsers,
  verify2FA
};